import script from "./universal-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./universal-card.vue?vue&type=script&setup=true&lang=ts"

import "./universal-card.vue?vue&type=style&index=0&id=098337eb&lang=scss"

const __exports__ = script;

export default __exports__